import { Calc, MidpointRounding } from '@skylab-shared/utils';
import { VatTableItem, VatTableItemRecalculation, VatTableItemRecalculationChanges, VatTableItemRecalculationChangesProperty } from './vat-table-item-recalculation';

export class VatTableItemNetRecalculation extends VatTableItemRecalculation {
    public recalculate(item: VatTableItem, precision: number, triggeredBy?: VatTableItemRecalculationChangesProperty): Readonly<Required<VatTableItem>> {
        const result = { ...item };

        const tBy = triggeredBy as VatTableItemRecalculationChangesProperty;

        if (VatTableItemRecalculationChanges.grossChanged(tBy)) {
            this.recalculateFromGross(result, precision);
        } else {
            this.recalculateFromNet(result, precision);
        }
        return <Required<VatTableItem>>result;
    }

    private recalculateFromNet(item: VatTableItem, precision: number): void {
        item.vatValue = Calc.round(item.netValue! * item.vatRate!, precision, MidpointRounding.AwayFromZero);
        item.grossValue = Calc.round(item.netValue! + item.vatValue, precision, MidpointRounding.AwayFromZero);
    }

    private recalculateFromGross(item: VatTableItem, precision: number): void {
        item.netValue = Calc.round(item.grossValue! / (1 + item.vatRate!), precision, MidpointRounding.AwayFromZero);
        this.recalculateFromNet(item, precision);
    }
}
